const mutations = {
  candidateInfo: (state, value) => {
    state.candidateInfo = value[0]
  }
}
export default mutations
